(function($) {
	formHelper.addIPeerRule({
		// ID of the Payment form on the WWW site
		// No need to call out the form id inside the iframe
		// The selector 'form' is always used
		form: '#form-mbt-step-1',
		status: {
			// SUCCESS is what we would do if BOTH the iframe cde
			// and the www forms are successful
			SUCCESS: '/tools/main-menu/manual-booking-tool/step-2',
			SESSION_EXPIRED: '/tools/main-menu/manual-booking-tool/error',
			ERROR: function() { 
				lDialog.close();
			}
		}
	});

	formHelper.addRule({
		form: '#form-mbt-step-1-NoPayment',
		status: {
			SUCCESS: '/tools/main-menu/manual-booking-tool/step-2',
			SESSION_EXPIRED: '/tools/main-menu/manual-booking-tool/error',
			ERROR: function() { 
				lDialog.close();
			}
		},
		xhrReady: function(xhrOptions) {
			xhrOptions.data['peer-status'] = 'SUCCESS';
		}
	});	

})(jQuery);

jQuery(function initHandleMbtStep1Form($) {
	$('.form-mbt-step-1').each(function(index, el) {

		var $container             = $(this);
		var $submitBtn		       = $container.find('.btn-submit');
		var $applyPromoBtn         = $container.find('.btn-apply-promocode');
		var $removePromoBtn        = $container.find('.btn-remove-promocode');

		// Always execute when the form 1st gets init.
		calculateFinalPrice();

		$('.js-spacea-discount').click(function() {
			$(this).closest('.checkbox').siblings().find('.js-spacea-discount').prop('checked', false);
		});

		$applyPromoBtn.click(function() {
			promocode = $('#promocode').val();
			originalprice = $('#original-price').val();
			spaceadiscount = 0;

			$("input:checkbox[name=spacea-discount]:checked").each(function () {
			    if($(this).is(':checked'))
      				spaceadiscount = $(this).val();
			});

			if(promocode !== '' && originalprice > 0) {
				$.ajax({
					method: "POST",
					url: "/h/mbt/ApplyPromoCode",
					dataType: 'JSON',
					data: { promocode: promocode, originalprice: originalprice, spaceadiscount: spaceadiscount },
				})
				.done(function( data ) {
					if (data.validPromo === 'yes') {
		                // Success
		                // Turn off
		                $('.js-fh-error-invalid-promocode').css('display','none');
		                $('.js-fh-error-invalid-promocode-req').css('display','none');
						$('.js-promocode-apply').css('display','none');
						
						// Turn on
						$('.js-promocode-name').html(promocode);
						$('.js-promocode-discount-amount').html(data.promocodeDiscount);
						$('#promodiscount').val(data.promocodeDiscount);
						$('#final-price').val(data.finalPrice);
						$('.js-promocode-applied').css('display','block');

						// Validate the Booking form name
						validateIsNoPaymentManualBookingForm(data.finalPrice);
		            } 
		            else {
		                $('.js-fh-error-invalid-promocode').css('display','block');
		            }
				})
				.fail(function() {
					alert( "An unexpected error has occurred." );
				});
			}
			else {
				$('.js-fh-error-invalid-promocode-req').css('display','block');
			}
		});

		$removePromoBtn.click(function() {		
			$.ajax({
				method: "POST",
				url: "/h/mbt/RemovePromoCode",
				dataType: 'JSON',
			})
			.done(function( data ) {
				// Success
				// Restore
				$('.js-promocode-applied').css('display','none');
				$('#promocode').val('');
				$('#promodiscount').val('');

				// Apply
				$('.js-final-price').html(data.finalPrice);
				$('.js-promocode-apply').css('display','block');

				calculateFinalPrice();

				// Validate the Booking form name
				validateIsNoPaymentManualBookingForm(data.finalPrice);
			})
			.fail(function() {
				alert( "An unexpected error has occurred." );
			});
		});

		$submitBtn.click(function() {
			// Diaplay a lDialog loading shadow box
			checkValidityValue = $('.form-mbt-step-1')[0].checkValidity(); // returns true/false

			if(checkValidityValue === true) {
				// Browser checkValidity is true, load loading ldialog shadow box
				launchLoadingDialog();
			}
		});

		$('input[name=original-price]').change(function() {
			// Original Price onChange event
			calculateFinalPrice();
		});


		$('[name="spacea-discount"]').click( function() {
			// SpaceA Discount onClick event
			calculateFinalPrice();
		});

		function calculateFinalPrice() {
			// Calculate and set the final price
			var $finalPrice = 0;
			var $originalPrice = 0;
			var $promodiscount = 0;
			var $varSAD = 0;
			
			if(parseFloat($('#original-price').val()) > 0) {
				$originalPrice = parseFloat($('#original-price').val());
			}			

			if(parseFloat($originalPrice) > 0) {
				if(parseFloat($('#promodiscount').val()) > 0) {
					$promodiscount = parseFloat($('#promodiscount').val());
				}

				$("input:checkbox[name=spacea-discount]:checked").each(function () {
				    $varSAD = $(this).val();
				});
			}
		
			$finalPrice = parseFloat($originalPrice) - parseFloat($promodiscount) - parseFloat($varSAD);

			// Validate and set the booking form with finalPrice
			validateIsNoPaymentManualBookingForm($finalPrice);

			$('#final-price').val(parseFloat($finalPrice).toFixed(2));
		}	

		// pickadate forms elements
		// ------------------
		$('#conf-date').pickadate({
			min: -365,
			max: true,
			selectYears: 2,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});

		var $checkInData = $('#check-in-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var checkInDataPicker = $checkInData.pickadate('picker');

		var $checkOutDate = $('#check-out-date').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var checkOutDatePicker = $checkOutDate.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( checkInDataPicker.get('value') ) {
			checkOutDatePicker.set('min', checkInDataPicker.get('select'));
		}
		
		if ( checkOutDatePicker.get('value') ) {
			checkInDataPicker.set('max', checkOutDatePicker.get('select'));
		}

		// When something is selected, update the "checkInData" and "checkOutDate" limits.
		checkInDataPicker.on('set', function(event) {
			if ( event.select ) {
				checkOutDatePicker.set('min', checkInDataPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				checkOutDatePicker.set('min', false);
			}
		});

		checkOutDatePicker.on('set', function(event) {
			if ( event.select ) {
				checkInDataPicker.set('max', checkOutDatePicker.get('select'));
			}
			else if ( 'clear' in event ) {
				checkInDataPicker.set('max', false);
			}
		});

		function validateIsNoPaymentManualBookingForm(finalPrice) {
			// Check if the form should be a no cost submission
			if(parseInt(finalPrice) === 0) {
				// Rename form id to submit the NoPayment FH addRule
				if($("#form-mbt-step-1").length > 0) {
					$('#form-mbt-step-1').attr('id','form-mbt-step-1-NoPayment');
				}

				// Remove NoPayment Info section
				$('.js-billing-information-block').css('display','none');
				$('.js-payment-information-block').css('display','none');

				// Remove required attributes
				$("#first-name-b").prop("required", false);
				$("#last-name-b").prop("required", false);
				$("#address1-b").prop("required", false);
				$("#city-b").prop("required", false);
				$("#state-province-b").prop("required", false);
				$("#postalcode-b").prop("required", false);
				$("#country-b").prop("required", false);
				$("#phone-b").prop("required", false);
			}
			else {
				// Rename form id to submit without NoPayment FH addRule
				if($('#form-mbt-step-1-NoPayment').length > 0) {
					$('#form-mbt-step-1-NoPayment').attr('id','form-mbt-step-1');
				}

				// Restore NoPayment Info section
				$('.js-billing-information-block').css('display','block');
				$('.js-payment-information-block').css('display','block');

				// Add required attributes
				$("#first-name-b").prop("required", true);
				$("#last-name-b").prop("required", true);
				$("#address1-b").prop("required", true);
				$("#city-b").prop("required", true);
				$("#state-province-b").prop("required", true);
				$("#postalcode-b").prop("required", true);
				$("#country-b").prop("required", true);
				$("#phone-b").prop("required", true);
			}
		}

		jQuery(function($) {
			// Same as traveler info checkbox feature to copy and populate traveler info
			$('[name="same-as-traveler-info"]').click( function() {
				if($(this).is(':checked')) {
					$('#first-name-b').val($('#first-name').val());
					$('#last-name-b').val($('#last-name').val());
					$('#address1-b').val($('#address1').val());
					$('#address2-b').val($('#address2').val());
					$('#city-b').val($('#city').val());
					$('#state-province-b').val($('#state-province').val());
					$('#postalcode-b').val($('#postalcode').val());
					$('#country-b').val($('#country').val());
					$('#phone-b').val($('#phone').val());
				}
			})
		});
	});
});

jQuery(function initHandleMbtStep2Form($) {
	$('#form-mbt-step-2').each(function(index, el) {

		var $container             = $(this);
		var $submitBtn		       = $container.find('.btn-submit');

		$submitBtn.click(function() {
			// Diaplay a lDialog loading shadow box
			checkValidityValue = $('#form-mbt-step-2')[0].checkValidity(); // returns true/false
		
			if(checkValidityValue === true) {
				// Browser checkValidity is true, load loading ldialog shadow box
				launchLoadingDialog();
			}
		});
	});
});